
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

import {AuthService} from './auth.service';
import { UserService } from '../user/user.service';
@Injectable()

export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router, private userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      if (route.data.permission) {
        if (this.userService.userHasPermission(route.data.permission) ) {
              return true;
        }else {this.router.navigate(['/']); }
      } else { return true; }
    }else {
      this.router.navigate(['/signin']);
    }

  }

  canActivateChild( childRoute: ActivatedRouteSnapshot,
                    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      if (childRoute.data.permission) {
        if (this.userService.userHasPermission(childRoute.data.permission) ) {
          return true;
        }else { this.router.navigate(['/']); }
      } else { return true; }
    }else {
      this.router.navigate(['/signin']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-guard.service.ts